var PerfectScrollbar = require('perfect-scrollbar').default;

var course_archive = (function( $ ) {

	var anim_speed = 400,
		$coming_up;

	var _init = function() {
		$coming_up = $('#course-archive-coming-up');

		_setup_course_filters();

		if ( $coming_up.length > 0 ) {
			_setup_coming_up();
		}
	};

	var _setup_coming_up = function() {
		var $carousel = $coming_up.find('.carousel');

		$carousel.owlCarousel( {
			margin: 24,
			stagePadding: 0,
			loop: false,
			dots: true,
			responsive:{
				0: {
					items: 1,
					loop: true,
					stagePadding: 60,
				},
				481: {
					items: 2,
				},
				992: {
					items: 4
				}
			}
		} );
	}

	var _setup_course_filters = function() {
		var $filters = $('#course-archive-filter-panel, #course-archive-business-filter-panel');

		$filters.find('.filters-heading a.open-filters').on('click', (e) => {
			e.preventDefault();

			_toggle_filters_panel( $filters );
		})

		$filters.find('a.open-panel').each((index, item) => {
			let $link = $(item);

			$link.on('click', (e) => {
				e.preventDefault();

				_toggle_filter_panel($link.closest('.filter-section'));
			});

			// Default filter to open
			// _open_filter_panel($link.closest('.filter-section'));
		});
	}

	var _toggle_filters_panel = function( $filters ) {
		if ( $filters.hasClass('animating') ) {
			return;
		}

		$filters.addClass('animating');

		if ( $filters.hasClass('open') ) {
			$filters.find('.filters-wrapper').slideUp(anim_speed);
			$filters.find('.filters-header a.open-filters').removeClass('open');
			$filters.addClass('closed').removeClass('open');
		} else {
			$filters.find('.filters-wrapper').slideDown(anim_speed);
			$filters.find('.filters-header a.open-filters').addClass('open');
			$filters.addClass('open').removeClass('closed');
		}

		setTimeout(() => {
			$filters.removeClass('animating');
		}, anim_speed);
	}

	var _toggle_filter_panel = function($panel) {
		if ( $panel.hasClass('animating') ) {
			return;
		}

		$panel.addClass('animating');

		if ( $panel.hasClass('open') ) {
			_close_filter_panel($panel);
		} else {
			_open_filter_panel($panel);
		}

		setTimeout(() => {
			$panel.removeClass('animating');
		}, anim_speed)
	}

	var _open_filter_panel = function( $panel ) {
		$panel.find('.filter-values').slideDown(anim_speed);

		$panel.removeClass('closed').addClass('open');
	}

	var _close_filter_panel = function( $panel ) {
		$panel.find('.filter-values').slideUp(anim_speed);

		$panel.removeClass('open').addClass('closed');
	}

	if ( $( 'body.post-type-archive-tutorial' ).length || $( 'body.tax-course_category' ).length || $( 'body.tax-course_type' ).length || $( 'body.tax-skill_level' ).length ) {
		$( _init );
	}

	return {}

})( jQuery );

module.exports = course_archive;